var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.item.archived)?_c('i',{staticClass:"af-icons af-icons-archived danger align-middle"}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.item.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }